﻿package com.mgacreative.hotelru.feature.reservation.di

import com.mgacreative.hotelru.feature.reservation.ui.*
import com.mgacreative.hotelru.feature.reservation.ui.create.CreateReservationViewModel
import com.mgacreative.hotelru.feature.reservation.ui.checkout.CheckOutViewModel
import com.mgacreative.hotelru.feature.reservation.ui.checkin.CheckInViewModel
import org.koin.core.module.dsl.viewModel
import org.koin.dsl.module

fun getReservationFeatureModule() = module {
    viewModel { ReservationViewModel(get(), get(), get()) }
    viewModel { CreateReservationViewModel(get(), get(), get(), get()) }
    viewModel { CheckOutViewModel(get(), get(), get()) }
    viewModel { CheckInViewModel(get(), get(), get(), get()) }
    viewModel { CalendarViewModel(get(), get()) }
    viewModel { NewReservationCalendarViewModel(get(), get()) }
}

